export default "__VITE_ASSET__CHTuvyIy__"